<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b"><a id="toc"></a><a id="page_ix">CONTENTS</a></h2><a id="page_ix">
</a><p class="toc1"><a id="page_ix"></a><a class="nounder" href="#/pref02#pref02"><em>List of Maps and Figures</em></a></p>
<p class="toc1"><a class="nounder" href="#/pref03#pref03"><em>List of Illustrations</em></a></p>
<p class="toc1"><a class="nounder" href="#/pref04#pref04"><em>List of Terms and Abbreviations</em></a></p>
<p class="toc1"><a class="nounder" href="#/pref05#pref05"><em>Foreword</em></a></p>
<p class="toc2"><a class="nounder" href="#/pref06#pref06"><em>Preface and Acknowledgments</em></a></p>
<p class="toc1"><a class="nounder" href="#/ch00#ch00">Introduction</a></p>
<p class="toc1"><a class="nounder" href="#/ch00a#ch00a">Prologue: The Call of the Ice</a></p>
<p class="toc1"><a class="nounder" href="#/ch01#ch01">Chapter 1. The International Geophysical Year: Idea to Reality</a></p>
<p class="toc1"><span class="nounder" href="#/ch02#ch02" title="Link target outside of Sample">Chapter 2. All Hands on Deck: Logistics for the High Latitudes</span></p>
<p class="toc1"><a id="page_x"></a><span class="nounder" href="#/ch03#ch03" title="Link target outside of Sample">Chapter 3. Gaining a Foothold: Operations Base at McMurdo Sound</span></p>
<p class="toc1"><span class="nounder" href="#/ch04#ch04" title="Link target outside of Sample">Chapter 4. Little America V: Science Flagship on the Ice Shelf</span></p>
<p class="toc1"><span class="nounder" href="#/ch05#ch05" title="Link target outside of Sample">Chapter 5. Marie Byrd Land: Crevasse Junction, Privation Station</span></p>
<p class="toc1"><span class="nounder" href="#/ch06#ch06" title="Link target outside of Sample">Chapter 6. South Pole: Dropped From the Sky</span></p>
<p class="toc1"><span class="nounder" href="#/ch07#ch07" title="Link target outside of Sample">Chapter 7. The Gap Stations: Hallett, Wilkes, and Ellsworth</span></p>
<p class="toc1"><span class="nounder" href="#/ch08#ch08" title="Link target outside of Sample">Chapter 8. On the Eve: People, Preparations, Policies</span></p>
<p class="toc1"><span class="nounder" href="#/ch09#ch09" title="Link target outside of Sample">Chapter 9. Comprehending the Cold: Antarctic Weather Quest</span></p>
<p class="toc1"><span class="nounder" href="#/ch10#ch10" title="Link target outside of Sample">Chapter 10. Looking Up: The Physics of the Atmosphere</span></p>
<p class="toc1"><span class="nounder" href="#/ch11#ch11" title="Link target outside of Sample">Chapter 11. Under Foot: Ice by the Mile</span></p>
<p class="toc1"><span class="nounder" href="#/ch12#ch12" title="Link target outside of Sample">Chapter 12. Life on the Ice: The Experience</span></p>
<p class="toc2"><span class="nounder" href="#/app01#app01" title="Link target outside of Sample">Epilogue: Science and Peace, Continuity and Change</span></p>
<p class="toc1"><span class="nounder" href="#/notes#notes" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc1"><span class="nounder" href="#/app02#app02" title="Link target outside of Sample"><em>Notes on Sources</em></span></p>
<p class="toc1"><span class="nounder" href="#/index#index" title="Link target outside of Sample"><em>Index</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?76b3d628